import { WDHAccordionSpot } from '../../../../wdh-feature/wdh-accordion-spot';
var wdhAccordionSpot = new WDHAccordionSpot('.accordion-spot:not(.tabs)');
wdhAccordionSpot.run();